import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

const CLINIC_ACCENT = '#04c2ff';

const buildChartRows = (rows) => {
    const sortedRows = [...rows].sort((left, right) => (right.case_count || 0) - (left.case_count || 0));
    const maxCaseCount = sortedRows[0]?.case_count || 0;

    return sortedRows.map((row, index) => ({
        barWidth: maxCaseCount > 0 ? `${(row.case_count / maxCaseCount) * 100}%` : '0%',
        caseCount: row.case_count || 0,
        clinicId: row.clinic_id,
        clinicName: row.clinic_name || 'Unknown Clinic',
        rank: index + 1,
    }));
};

function ScanVolumeByClinicChart({ analytics }) {
    const rows = analytics?.rows || [];
    const chartRows = buildChartRows(rows);
    const hasRows = rows.length > 0;

    return (
        <section className="dashboard-chart-card dashboard-chart-card--clinic">
            <div className="dashboard-chart-header dashboard-chart-header--with-icon">
                <h2>Scan Volume by Clinic</h2>
                <Tooltip title="Top clinics by total scan volume for the selected date range.">
                    <InfoOutlinedIcon className="dashboard-chart-info-icon" fontSize="small" />
                </Tooltip>
            </div>
            <div className={`dashboard-chart-body${hasRows ? ' dashboard-chart-body--auto' : ''}`}>
                {hasRows ? (
                    <div className="dashboard-clinic-chart">
                        <div className="dashboard-clinic-chart__header">
                            <span>Clinic</span>
                            <span aria-hidden="true" />
                            <span>Total Cases</span>
                        </div>
                        <div className="dashboard-clinic-chart__rows">
                            {chartRows.map((row) => (
                                <div key={row.clinicId} className="dashboard-clinic-chart__row">
                                    <div className="dashboard-clinic-chart__clinic-cell">
                                        <span className="dashboard-clinic-chart__rank">{row.rank}</span>
                                        <span className="dashboard-clinic-chart__name">{row.clinicName}</span>
                                    </div>
                                    <div className="dashboard-clinic-chart__bar-cell">
                                        <div
                                            className="dashboard-clinic-chart__bar"
                                            style={{
                                                backgroundColor: CLINIC_ACCENT,
                                                width: row.barWidth,
                                            }}
                                        />
                                    </div>
                                    <div className="dashboard-clinic-chart__count">{row.caseCount}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="dashboard-chart-empty">
                        <p>No data for the selected date range.</p>
                        <p>Try expanding the date range or adjusting filters.</p>
                    </div>
                )}
            </div>
        </section>
    );
}

ScanVolumeByClinicChart.propTypes = {
    analytics: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({
            case_count: PropTypes.number,
            clinic_id: PropTypes.string,
            clinic_name: PropTypes.string,
        })),
    }),
};

ScanVolumeByClinicChart.defaultProps = {
    analytics: null,
};

export default ScanVolumeByClinicChart;
